import * as React from "react";
import {ApplicationContext} from "../../../ApplicationContext";
import {CmsContent} from "../../../Model/CmsContent/CmsContent";
import {optHtmlContent, renderDynamicContent} from "../../../Utilities/CmsUtilities";

interface PortInInputProps {
    readonly formId: string
    readonly cmsContent: CmsContent[];
}

/**
 * Function will render the port information section of the Single page sign up page
 */
const PortInInput = (props: PortInInputProps): JSX.Element | null => {

    const optPortInSummary = optHtmlContent(props.cmsContent, "sp-port-in-summary")

    if (!optPortInSummary) return null

    return (
        <>
            <div className={"margin-top-5"}>
                {renderDynamicContent(optPortInSummary)}
                <div className="form-row" style={{display: "flex"}}>
                    <div className="form-group" style={{flex: 2}}>
                        <label htmlFor="pacCode" className="sp-text-primary">
                            Mobile Number
                        </label>
                        <input
                            type="text"
                            id="portInNumber"
                            name="portInNumber"
                            placeholder="0----------"
                        />
                        <div
                            id={`${props.formId}:portInNumber-error-wrapper`}
                            className="sp-form-field-error-wrapper"
                            style={{display: "none"}}>

                            <div id={`${props.formId}:portInNumber-error`}
                                 className="sp-form-text-error"></div>
                        </div>

                    </div>

                    <div className="form-group" style={{flex: 2}}>
                        <label htmlFor="pacCode" className="sp-text-primary">
                            Switching Code
                        </label>
                        <input
                            type="text"
                            id="pacCode"
                            name="pacCode"
                            placeholder="ABC123456"
                        />
                        <div
                            id={`${props.formId}:pacCode-error-wrapper`}
                            className="sp-form-field-error-wrapper"
                            style={{display: "none"}}>

                            <div id={`${props.formId}:pacCode-error`}
                                 className="sp-form-text-error"></div>
                        </div>
                    </div>
                </div>
                <div
                    id={`${props.formId}:portInDetails-error-wrapper`}
                    className="sp-form-field-error-wrapper"
                    style={{display: "none"}}>

                    <div id={`${props.formId}:portInDetails-error`}
                         className="sp-form-text-error"></div>
                </div>
            </div>
        </>
    )
}

export default PortInInput
